export default __webpack_public_path__ + "static/product_item_003-0a439abab2ed648f21457c640886bdf7.jpg";